import React from "react";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { FileBox, PackageSearch, UserRoundCog } from "lucide-react";
// import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import Logo from "src/img/logo.png";
import {
  ApplianceIcon,
  CustomersIcon,
  LogoutIcon,
  UserIcon,
} from "src/img/svg";
import { useMutation } from "@tanstack/react-query";
import { logOut } from "src/services/api";
import { renderConfirmDialogueWithCustomLoader, renderToastMsg } from "src/utils/functions";

const SideBar = () => {
  // const { setUser, setToken } = useProtectedRoutesContext();

  const { mutate } = useMutation(logOut);

  const { pathname } = useLocation();
  return (
    <Sidebar
      style={{ borderColor: "#cfcfcf" }}
      backgroundColor="white"
      customBreakPoint="1000px"
      width="220px"
    >
      <div className="p-[20px]">
        <img src={Logo} alt="revocube-energies" className="w-[15rem]" />
      </div>
      <Menu
        menuItemStyles={{
          root: ({ active }) => {
            return {
              color: active ? "var(--primary-color)" : "#525252",
              backgroundColor: active ? "#FFEDED" : undefined,
              marginBottom: 5,

              "&:hover": {
                backgroundColor: "#FFEDED",
                color: "var(--primary-color)",
              },
            };
          },
          button: {
            paddingInline: 15,
          },

          label: {
            fontSize: "1.4rem",
            fontWeight: "500",
          },
        }}
        rootStyles={{
          // width: "80%",
          marginInline: "auto",
          marginTop: 20,
        }}
      >
        {/*  <MenuItem
                    component={<Link to="/admin/dashboard" />}
                    icon={<DashboardIcon />}
                    active={pathname === "/admin/dashboard"}
                >
                    Dashboard
                </MenuItem> */}
        <MenuItem
          component={<Link to="/admin/appliances" />}
          icon={<ApplianceIcon />}
          active={pathname === "/admin/appliances"}
        >
          Appliances
        </MenuItem>
        <MenuItem
          component={<Link to="/admin/inventory" />}
          icon={<PackageSearch />}
          active={pathname === "/admin/inventory"}
        >
          Inventory
        </MenuItem>
        <MenuItem
          component={<Link to="/admin/orders" />}
          icon={<FileBox />}
          active={pathname === "/admin/orders"}
        >
          Stock Orders
        </MenuItem>

        <MenuItem
          component={<Link to="/admin/customers" />}
          icon={<CustomersIcon />}
          active={pathname === "/admin/customers"}
        >
          Customers
        </MenuItem>

        <MenuItem
          component={<Link to="/admin/profiles" />}
          icon={<UserIcon />}
          active={pathname === "/admin/profiles"}
        >
          Admin Profiles
        </MenuItem>
        <MenuItem
          component={<Link to="/admin/settings" />}
          icon={<UserRoundCog />}
          active={pathname === "/admin/settings"}
        >
          Settings
        </MenuItem>

        <MenuItem
          className="mt-auto"
          icon={<LogoutIcon />}
          onClick={() => {
            renderConfirmDialogueWithCustomLoader(
              "Are you sure?",
              "Are you sure you want to Logout?",
              "Yes, Log out",
              async () => {
                await mutate(
                  {},
                  {
                    onSuccess: () => {
                      renderToastMsg("Logged out successfully", "success");
                      localStorage.clear();
                      window.location.reload();
                    },
                  }
                );
              }
            );
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Sidebar>
  );
};

export default SideBar;
